import { useEffect } from 'react'
import { Grid, makeStyles, Link, Typography, Box } from '@material-ui/core'
import { Card, CardHeader, CardBody, Text } from '@backstage/ui'
import { useEntity } from '@backstage/plugin-catalog-react'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'
import { parseEntityRef } from '@backstage/catalog-model'

const useStyles = makeStyles({
  iframeContainer: {
    width: '100%',
    height: '800px'
  },
  linkContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '8px'
  },
  linkIcon: {
    fontSize: '1rem',
    marginLeft: '4px',
    verticalAlign: 'middle'
  }
})

export const C4PortalContent = () => {
  const { entity } = useEntity()
  const classes = useStyles()
  const baseUrl = 'https://c4-portal.dev.sennder.tech'

  // Get the system from the entity relationships
  let systemName = ''

  if (entity.kind.toLowerCase() === 'system') {
    // For a system entity, use its own metadata name
    systemName = entity.metadata.name
  }
  // Check if the entity belongs to a system through part-of relationship
  else if (entity.relations) {
    const systemRelation = entity.relations.find(
      relation => relation.type === 'partOf' && relation.targetRef.startsWith('system:')
    )

    if (systemRelation) {
      systemName = parseEntityRef(systemRelation.targetRef).name
    }
  }

  // Generate a unique ID for the iframe
  const iframeId = `c4-diagram-${systemName || 'unknown'}`

  useEffect(() => {
    // Load the structurizr embed script
    const script = document.createElement('script')
    script.src = `${baseUrl}/static/js/structurizr-embed.js`
    script.async = true
    document.body.appendChild(script)

    return () => {
      // Clean up the script when component unmounts
      document.body.removeChild(script)
    }
  }, [])

  if (!systemName) {
    return (
      <Card>
        <CardHeader>
          <Text variant="title-x-small" weight="bold">
            C4 Portal Diagram
          </Text>
        </CardHeader>
        <CardBody>
          <p>
            No system found for this entity. This component needs to be part of a system
            to display its C4 diagram.
          </p>
        </CardBody>
      </Card>
    )
  }

  // Create the diagram URL based on the system name
  const diagramUrl = `${baseUrl}/embed/6?diagram=system___default___${systemName}_no_dependencies&diagramSelector=false&iframe=${iframeId}`
  const fullPageUrl = `${baseUrl}/share/6/diagrams#system___default___${systemName}_no_dependencies`

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card>
          <CardHeader>
            <Text variant="title-x-small" weight="bold">
              C4 Diagram
            </Text>
          </CardHeader>
          <CardBody>
            <Box className={classes.linkContainer}>
              <Link href={fullPageUrl} target="_blank" rel="noopener noreferrer">
                <Typography variant="body2" component="span">
                  Open in C4 Portal
                  <OpenInNewIcon className={classes.linkIcon} />
                </Typography>
              </Link>
            </Box>
            <div className={classes.iframeContainer}>
              <iframe
                id={iframeId}
                src={diagramUrl}
                width="100%"
                height="100%"
                allowFullScreen={true}
                title="C4 Diagram"
              />
            </div>
          </CardBody>
        </Card>
      </Grid>
    </Grid>
  )
}
